import React, {useMemo} from 'react'
import styled from 'styled-components'
import {WindowModeType} from 'types'
import {useWindowMode} from 'windows'
import {getBorder} from 'utils'
import convertUnit from 'lib/unit'
import TreePlantTreeUpperForm from './TreePlantTreeUpperForm'
import TreePlantTreeBottomForm from './TreePlantTreeBottomForm'
import {TreePlantTreeFormProps} from './TreePlantTreeFormProps'
import {TreePlantUploadImage} from '../UploadImage'
import {TreePlantUploadVideo} from '../UploadVideo'

interface StyledContainerProps {
  mode: WindowModeType
}

const StyledContainer = styled.div<StyledContainerProps>`
  ${({theme, mode}) => ({
    backgroundColor: theme.white_1,
    flexDirection: mode === 'website' ? 'row' : 'column',
    padding: mode !== 'website' ? 0 : convertUnit(20),
    border: mode !== 'website' ? 'none' : getBorder(1, 'solid', theme.gray_1),
    borderRadius: mode !== 'website' ? 0 : convertUnit(16),
    width: mode !== 'website' ? '100%' : convertUnit(900),
  })}
  display: flex;
  align-self: center;
  box-sizing: border-box;
  margin: auto;
`

const StyledSubContainer = styled.div`
  margin: ${convertUnit(20)};
  display: flex;
  flex: 1;
  flex-direction: column;
`
export default function TreePlantTreeForm({
  form,
  imageForm,
  videoForm,
  srcState,
}: TreePlantTreeFormProps) {
  const mode = useWindowMode()

  const handleRenderWeb = useMemo(
    () => (
      <StyledContainer mode={mode}>
        <StyledSubContainer>
          <TreePlantUploadImage imageForm={imageForm} />
          <TreePlantTreeUpperForm form={form} />
        </StyledSubContainer>
        <StyledSubContainer>
          <TreePlantTreeBottomForm form={form} />
          <TreePlantUploadVideo srcState={srcState} videoForm={videoForm} />
        </StyledSubContainer>
      </StyledContainer>
    ),
    [form, imageForm, mode, srcState, videoForm],
  )

  return <>{handleRenderWeb}</>
}
